import moment from "moment";
export const image_version = moment().format("YYYYMMDD");
const centers = [
  {
    name: "두써킷 본사 테스트",
    cid: "CT14S15143839.Pdfg3",
    userCode: "imp76426114",
    tierCode: "G01",
    payment: "iamport",
    pg: "html5_inicis",
    product_cid: "CT14S15143839.Pdfg3",
    pass_coupon_sale: true,
    address: {
      address1: "상호명 : (주)스마트핏 | 대표자 : 김경아",
      address2: "유선번호 : 051-583-9645",
      address3:
        "주소 : 부산 해운대구 수영강변대로 140 부산문화콘텐츠컴플렉스 712호",
    },
    receipt: {
      company: "(주) 두써킷",
      company_no: "370-85-00416",
      head: "김경아",
      tel: "051-728-8771",
      addr: "부산 해운대구 수영강변대로 140 부산문화콘텐츠컴플렉스 712호",
    },
    logo: "/img/main_logo_moon.png",
    pt_coupon_sale: true,
    whatsnew: [
      {
        main: "/img/whatsnew_ajoo.jpeg?v=221012",
        detail: "/img/whatsnew_ajoo_detail.jpeg?v=221012",
        maintxt1: "그룹운동 전문센터",
        maintxt2: "두써킷 아주점 그랜드 오픈!",
        date: "2022.10.12",
      },
      {
        main: "/img/whatsnew_jeongguan.png",
        detail: "/img/whatsnew_jeongguan_detail.jpeg",
        maintxt1: "그룹운동 전문센터",
        maintxt2: "두써킷 정관점 그랜드 오픈!",
        date: "2022.09.19",
      },
      {
        main: "/img/whatsnew_gohyen.png",
        detail: "/img/whatsnew_jeongguan_detail.jpeg",
        maintxt1: "그룹운동 전문센터",
        maintxt2: "두써킷 고현점 그랜드 오픈!",
        date: "2022.09.19",
      },
    ],
    center_info: [
      {
        youtube: "",
        images: [
          {
            original: "/img/C_okpo01.jpg?v=" + image_version,
            thumbnail: "/img/C_okpo01.jpg?v=" + image_version,
          },
          {
            original: "/img/C_okpo02.jpg?v=" + image_version,
            thumbnail: "/img/C_okpo02.jpg?v=" + image_version,
          },
          {
            original: "/img/C_okpo05.jpg?v=" + image_version,
            thumbnail: "/img/C_okpo05.jpg?v=" + image_version,
          },
          {
            original: "/img/C_okpo06.jpg?v=" + image_version,
            thumbnail: "/img/C_okpo06.jpg?v=" + image_version,
          },
        ],
        address: "부산 해운대구 수영강변대로 140 부산문화콘텐츠컴플렉스 712호",
        time: "운영시간: 오전 6:00 ~ 오후 10:00(거리두기로 인한 운영시간 변경가능)",
        latitude: 35.1727659,
        longitude: 129.125582,
        transportation: [
          {
            bus: "5-1, 36, 39, 40, 63, 115, 139, 141, 155, 181, 307(좌석), 1001(급행), 1002(급행)",
          },
        ],
      },
    ],
  },
  {
    name: "두써킷 정관점",
    cid: "CID00000009",
    payment: "iamport",
    pg: "danal_tpay",
    userCode: "imp76426114",
    tierCode: "G10",
    onfftid: "",
    product_cid: "CID00000009", // 상품정보
    pass_coupon_sale: true, // 패스쿠폰 판매
    // door_id : 45, // 본사테스트
    door_id: 46, // 정관점 출입문
    address: {
      address1: "상호명 : 두써킷 | 대표자 : 하홍수",
      address2: "사업자번호 : 359-68-00668 | 유선번호 : 051-728-8771",
      address3: "주소 : 부산광역시 기장군 정관읍 정관4로 42, 3층(풍산빌딩)",
    },
    receipt: {
      company: "두써킷",
      company_no: "359-68-00668",
      head: "하홍수",
      tel: "051-728-8771",
      addr: "부산 기장군 정관읍 정관4로 42, 풍산빌딩 3층 301호 두써킷 센터",
    },
    logo: "/img/main_logo_jeongguan.png",
    pt_coupon_sale: true,
    whatsnew: [
      {
        main: "/img/whatsnew_20240704_thumb.png",
        detail: "/img/whatsnew_20240704.png",
        popup: "/img/whatsnew_20240704_pop.png",
        maintxt1: "여름방학 학생이벤트!",
        maintxt2: "이번 여름방학 목표는 다이어트 성공?",
        date: "2024.07.04",
      },
    ],
    event_popup: 0,
    center_info: [
      {
        youtube: "https://www.youtube.com/embed/0V_4H-WUqVg",
        images: [
          {
            original: "/img/C_jeongguan01.jpg?v=" + image_version,
            thumbnail: "/img/C_jeongguan01.jpg?v=" + image_version,
          },
          {
            original: "/img/C_jeongguan02.jpg?v=" + image_version,
            thumbnail: "/img/C_jeongguan02.jpg?v=" + image_version,
          },
          {
            original: "/img/C_jeongguan03.jpg?v=" + image_version,
            thumbnail: "/img/C_jeongguan03.jpg?v=" + image_version,
          },
          {
            original: "/img/C_jeongguan04.jpg?v=" + image_version,
            thumbnail: "/img/C_jeongguan04.jpg?v=" + image_version,
          },
        ],
        address:
          "부산 기장군 정관읍 정관4로 42, 풍산빌딩 3층 301호 두써킷 센터",
        time: "운영시간: 오전 6:00 ~ 오후 10:00(거리두기로 인한 운영시간 변경가능)",
        latitude: 35.326227555845335,
        longitude: 129.17126266781744,
        transportation: [
          { bus: "롯데캐슬 : 37번, 182번" },
          { bus: "계룡리슈빌 : 37번, 182번" },
          {
            bus: "정관주민자치회관 : 기장군8번(마을), 73번, 107번, 182번, 184번, 188번, 302번, 1008번(좌석), 1010번(좌석)",
          },
        ],
      },
    ],
    sns_review: {
      nplace:
        "https://m.place.naver.com/place/34228866/review/ugc?type=photoView",
      blog: "https://m.blog.naver.com/smartfit8",
      kakaomap: "https://place.map.kakao.com/1277899956#review",
      googlemap:
        "https://www.google.com/maps/place/%EB%91%90%EC%8D%A8%ED%82%B7%EC%A0%95%EA%B4%80%EC%A0%90/data=!3m1!4b1!4m6!3m5!1s0x356885ce90bc8459:0x3dbfe20f97b77d59!8m2!3d35.3262918!4d129.1712694!16s%2Fg%2F11tflpt023?entry=ttu",
      insta:
        "https://www.instagram.com/docircuit_jeonggwan/?igshid=NTA5ZTk1NTc%3D",
    },
  },
  {
    name: "두써킷 고현점",
    cid: "_CT17X10111035.huwy5",    //26.06.04. 최명화 부장님께서 센터 종료로 인하여 어플에서 접근 불가하도록 수정 요청
    payment: "iamport",
    pg: "danal_tpay",
    userCode: "imp76426114",
    tierCode: "G11",
    onfftid: "",
    product_cid: "_CT17X10111035.huwy5",
    pass_coupon_sale: false,
    address: {
      address1: "상호명 : 주식회사 두써킷 | 대표자 : 김경아",
      address2: "사업자번호: 308-10-95899 | 유선번호 : 055-635-9886",
      address3:
        "주소 : 경상남도 거제시 거제중앙로31길 12-1, 2층(고현동, 스타빌딩)",
    },
    receipt: {
      company: "(주) 두써킷",
      company_no: "308-10-95899",
      head: "김경아",
      tel: "055-635-9886",
      addr: "경남 거제시 거제중앙로31길 12-1 2층",
    },
    logo: "/img/main_logo_gohyeon.png",
    pt_coupon_sale: true,
    whatsnew: [
      {
        main: "/img/whatsnew_20240704_thumb.png",
        detail: "/img/whatsnew_20240704_go.jpeg",
        popup: "/img/whatsnew_20240704_pop.png",
        maintxt1: "여름방학 학생이벤트!",
        maintxt2: "이번 여름방학 목표는 다이어트 성공?",
        date: "2024.07.04",
      },
    ],
    event_popup: 0,
    center_info: [
      {
        youtube: "",
        images: [
          {
            original: "/img/C_gohyeon01.jpeg?v=" + image_version,
            thumbnail: "/img/C_gohyeon01.jpeg?v=" + image_version,
          },
          {
            original: "/img/C_gohyeon02.jpeg?v=" + image_version,
            thumbnail: "/img/C_gohyeon02.jpeg?v=" + image_version,
          },
          {
            original: "/img/C_gohyeon03.jpg?v=" + image_version,
            thumbnail: "/img/C_gohyeon03.jpg?v=" + image_version,
          },
          // {
          //     original: '/img/C_gohyeon04.jpg?v=' + image_version,
          //     thumbnail: '/img/C_gohyeon04.jpg?v=' + image_version,
          // },
        ],
        address: "경남 거제시 거제중앙로31길 12-1",
        time: "운영시간: 오전 6:00 ~ 오후 10:00(거리두기로 인한 운영시간 변경가능)",
        latitude: 34.89081846843479,
        longitude: 128.6206275250881,
        transportation: [
          { bus: "중앙공영주차장 : 1138번" },
          { bus: "웨딩블랑 : 1135번" },
          { bus: "GS슈퍼마켓 : 1136번" },
        ],
      },
    ],
  },
  {
    name: "[중단] 두써킷 아주점",
    cid: "CT14Z01170314.HXZb9",
    userCode: "imp76426114",
    tierCode: "G12",
    payment: "iamport",
    pg: "danal_tpay",
    product_cid: "CT14Z01170314.HXZb9",
    pass_coupon_sale: false,
    door_id: 47,
    address: {
      address1: "상호명 : 주식회사 애니필라거제옥포점 | 대표자 : 조은주",
      address2: "사업자번호: 688-86-01948 | 유선번호 : 055-687-9642",
      address3: "주소 : 경상남도 거제시 옥포대첩로 38, 7층(옥포동, 유라빌딩)",
    },
    receipt: {
      company: "주식회사 애니필라거제옥포점",
      company_no: "688-86-01948",
      head: "조은주",
      tel: "055-687-9642",
      addr: "경상남도 거제시 옥포대첩로 38, 7층",
    },
    logo: "/img/main_logo_ajoo.png",
    pt_coupon_sale: false,
    whatsnew: [],
  },
  {
    name: "[중단] 두써킷 아주점",
    cid: "CID00000017",
    userCode: "imp76426114",
    tierCode: "G12",
    payment: "iamport",
    pg: "danal_tpay",
    product_cid: "CID00000017",
    pass_coupon_sale: true,
    door_id: 47,
    address: {
      address1: "상호명 : 주식회사 두써킷아주점 | 대표자 : 조은주",
      address2: "사업자번호: 688-86-01948 | 유선번호 : 055-687-9629",
      address3: "주소 : 경상남도 거제시 아주1로2길 25, 301호(아주동, 가야빌딩)",
    },
    receipt: {
      company: "주식회사 두써킷아주점",
      company_no: "688-86-01948",
      head: "조은주",
      tel: "055-687-9629",
      addr: "경상남도 거제시 아주1로2길 25, 301호(아주동, 가야빌딩)",
    },
    logo: "/img/main_logo_ajoo.png",
    whatsnew: [],
    center_info: [
      {
        youtube: "",
        images: [
          {
            original: "/img/C_ajoo01.jpg?v=" + image_version,
            thumbnail: "/img/C_ajoo01.jpg?v=" + image_version,
          },
          {
            original: "/img/C_ajoo02.jpeg?v=" + image_version,
            thumbnail: "/img/C_ajoo02.jpeg?v=" + image_version,
          },
          {
            original: "/img/C_ajoo03.jpeg?v=" + image_version,
            thumbnail: "/img/C_ajoo03.jpeg?v=" + image_version,
          },
          {
            original: "/img/C_ajoo04.jpg?v=" + image_version,
            thumbnail: "/img/C_ajoo04.jpg?v=" + image_version,
          },
        ],
        address: "경상남도 거제시 아주1로2길 25, 가야빌딩 301호",
        time: "운영시간: 오전 6:00 ~ 오후 10:00(거리두기로 인한 운영시간 변경가능)",
        latitude: 34.86704962164813,
        longitude: 128.68947287213268,
        transportation: [
          {
            bus: "아주농협(코오롱하늘채아파트 방면) : 16번, 16-2번, 16-4번, 14-1번, 3000번",
          },
          {
            bus: "아주농협(용소 방면) : 16-1번, 16-3번, 16-5번, 14-1번, 20-1번, 3000번",
          },
          {
            bus: "대우조선해양남문(대우조선해양정문 방면) : 10번, 11번, 22번, 32-1번, 10-3번, 10-5번, 12번",
          },
          {
            bus: "대우조선해양남문(용소 방면) : 10번, 11번, 22번, 32-1번, 4000번, 10-1번, 10-2번",
          },
        ],
      },
    ],
  },
  {
    name: "[중단] 두써킷 문래점",
    cid: "CID00000018",
    payment: "iamport",
    pg: "danal_tpay",
    userCode: "imp76426114",
    tierCode: "G14",
    onfftid: "",
    product_cid: "CID00000018", // 상품정보
    pass_coupon_sale: false, // 패스쿠폰 판매
    // door_id : 45, // 본사테스트
    door_id: 0, // 정관점 출입문
    address: {
      address1: "상호명 : 두써킷 문래점 | 대표자 : 하성호",
      address2: "사업자번호 : 248-76-00441 | 유선번호 : 02-2677-9585",
      address3:
        "주소 : 서울특별시 영등포구 문래로 89, 5층 501,502호(문래동3가, 문래비즈타워)",
    },
    receipt: {
      company: "(주) 두써킷",
      company_no: "248-76-00441",
      head: "하성호",
      tel: "02-2677-9585",
      addr: "서울특별시 영등포구 문래로 89, 5층 501,502호(문래동3가, 문래비즈타워)",
    },
    logo: "/img/main_logo_moon.png",
    pt_coupon_sale: false,
    whatsnew: [],
    event_popup: undefined,
    center_info: [
      {
        youtube: "",
        images: [
          {
            original: "/img/C_moon01.jpeg?v=" + image_version,
            thumbnail: "/img/C_moon01.jpeg?v=" + image_version,
          },
        ],
        address:
          "서울특별시 영등포구 문래로 89, 5층 501,502호(문래동3가, 문래비즈타워)",
        time: "운영시간: 오전 6:00 ~ 오후 10:00(거리두기로 인한 운영시간 변경가능)",
        latitude: 37.519602971854,
        longitude: 126.89189178122,
        transportation: [
          { bus: "문래힐스테이트아파트 (양평1동주민센터방면) : 641번, 6625번" },
          { bus: "문래힐스테이트아파트 (영문초등학교 방면) : 영등포05번" },
          {
            bus: "문래힐스테이트아파트 (문래역방면) : 641번, 6625번, 영등포05번",
          },
        ],
      },
    ],
    sns_review: {
      nplace: "https://naver.me/G7DXjK2m",
      blog: " https://blog.naver.com/docircuit_mullae",
      kakaomap: "https://place.map.kakao.com/1446831712",
      googlemap: "https://goo.gl/maps/za5eyiRZZsG22gMk7",
      insta: "https://www.instagram.com/docircuit_mullae/?next=%2F",
    },
  },
  {
    name: "[중단] 두써킷 제주노형점",
    cid: "__CID00000019",
    userCode: "imp76426114",
    tierCode: "D19",
    // userCode:"imp03087404",
    // tierCode:"T01",
    payment: "iamport",
    pg: "danal_tpay",
    product_cid: "CID00000019",
    pass_coupon_sale: true,
    door_id: 47,
    address: {
      address1: "상호명 : 주식회사 두써킷제주노형점 | 대표자 : 김준영",
      address2: "사업자번호: 413-03-25697 | 유선번호 : 064-748-9679",
      address3: "주소 : 제주 특별자치도 제주시 원노형로 54(노형동)",
    },
    receipt: {
      company: "주식회사 두써킷제주노형점",
      company_no: "413-03-25697",
      head: "김준영",
      tel: "064-748-9679",
      addr: "제주 특별자치도 제주시 원노형로 54(노형동)",
    },
    logo: "/img/main_logo_jejunohyeong.png",
    whatsnew: [],
    event_popup: undefined,
    center_info: [
      {
        youtube: "https://www.youtube.com//embed/oo2uOQIbRIc",
        images: [
          {
            original: "/img/C_jejunohyeong01.jpeg?v=" + image_version,
            thumbnail: "/img/C_jejunohyeong01.jpeg?v=" + image_version,
          },
          {
            original: "/img/C_jejunohyeong02.jpeg?v=" + image_version,
            thumbnail: "/img/C_jejunohyeong02.jpeg?v=" + image_version,
          },
          {
            original: "/img/C_jejunohyeong03.jpeg?v=" + image_version,
            thumbnail: "/img/C_jejunohyeong03.jpeg?v=" + image_version,
          },
          {
            original: "/img/C_jejunohyeong04.jpeg?v=" + image_version,
            thumbnail: "/img/C_jejunohyeong04.jpeg?v=" + image_version,
          },
        ],
        address: "제주 특별자치도 제주시 원노형로 54(노형동)",
        // time: "운영시간: 오전 6:00 ~ 오후 10:00(거리두기로 인한 운영시간 변경가능)",
        latitude: 33.4837433,
        longitude: 126.48466,
        transportation: [
          {
            bus: "롯데마트[북] : 800번",
          },
          {
            bus: "신제주오피스텔[서] : 332번, 336번, 3001번",
          },
          {
            bus: "원노형 : 316번",
          },
          {
            bus: "한라병원[서] : 600번, 182번, 151번",
          },
        ],
      },
    ],
  },
  {
    name: "두써킷 파주운정점",
    cid: "_CT25Z16161026.irtu8", // 26.02.25 폐업 의사 및 26.02.26 문자 확인
    payment: "iamport",
    pg: "danal_tpay",
    userCode: "imp30780740",
    tierCode: "_D01",
    onfftid: "",
    product_cid: "_CT25Z16161026.irtu8", // 상품정보
    pass_coupon_sale: false, // 패스쿠폰 판매
    address: {
      address1: "상호명 : 두써킷 파주운정점 | 대표자 : 임승빈",
      address2: "사업자번호 : 176-42-00495 | 유선번호 : 031-942-0250",
      address3: "주소 : 경기도 파주시 청암로 17번길 47, 302호",
    },
    receipt: {
      company: "두써킷 파주운정점",
      company_no: "176-42-00495",
      head: "임승빈",
      tel: "031-942-0250",
      addr: "경기도 파주시 청암로 17번길 47, 302호",
    },
    logo: "/img/main_logo_pajuunjeong.png",
    pt_coupon_sale: true,
    center_info: [
      {
        youtube: "",
        images: [
          {
            original: "/img/pajuunjeong01.jpeg",
            thumbnail: "/img/pajuunjeong01.jpeg",
          },
          {
            original: "/img/pajuunjeong02.jpeg",
            thumbnail: "/img/pajuunjeong02.jpeg",
          },
          {
            original: "/img/pajuunjeong03.jpeg",
            thumbnail: "/img/pajuunjeong03.jpeg",
          },
        ],
        address: "경기도 파주시 청암로 17번길 47, 302호",
        time: "운영시간: 오전 9:00 ~ 오후 10:00, 주말 공휴일 휴무",
        latitude: 37.728872,
        longitude: 126.73483,
        transportation: [
          { bus: "산내마을 3단지 : 70-1번, 072번, 080B번, 085번" },
          {
            bus: "산내마을중심상가(중) : 80번, 070B번, 071번, 074번, 076번, 087번",
          },
        ],
      },
    ],
    sns_review: {
      // nplace:
      //   "https://m.place.naver.com/place/34228866/review/ugc?type=photoView",
      // blog: "https://m.blog.naver.com/smartfit8",
      // kakaomap: "https://place.map.kakao.com/1277899956#review",
      // googlemap:
      //   "https://www.google.com/maps/place/%EB%91%90%EC%8D%A8%ED%82%B7%EC%A0%95%EA%B4%80%EC%A0%90/data=!3m1!4b1!4m6!3m5!1s0x356885ce90bc8459:0x3dbfe20f97b77d59!8m2!3d35.3262918!4d129.1712694!16s%2Fg%2F11tflpt023?entry=ttu",
      // insta:
      //   "https://www.instagram.com/docircuit_jeonggwan/?igshid=NTA5ZTk1NTc%3D",
    },
  },
];

const get_center_config = (cid) => {
  let idx = centers.findIndex((el) => el.cid === cid);
  return centers[idx];
};

export default get_center_config;

// payment 카드결제모듈 : iamport / onoffkorea
